export default __webpack_public_path__ + "static/media/japon-text1.ef88b1eb.png";